export default "__VITE_ASSET__CsNJkgob__"